import { mergeProps } from '@zag-js/solid';
import { Show } from 'solid-js';
import { createSplitProps } from '../../utils/create-split-props';
import { useRenderStrategyContext } from '../../utils/render-strategy';
import { ark } from '../factory';
import { PresenceProvider, usePresence } from '../presence';
import { useTabsContext } from './use-tabs-context';
export const TabContent = (props) => {
    const [contentProps, localProps] = createSplitProps()(props, ['value']);
    const api = useTabsContext();
    const renderStrategyProps = useRenderStrategyContext();
    const presenceApi = usePresence(mergeProps(renderStrategyProps, () => ({
        present: api().value === contentProps.value,
        immediate: true,
    })));
    const mergedProps = mergeProps(() => api().getContentProps(contentProps), () => presenceApi().presenceProps, localProps);
    return (<PresenceProvider value={presenceApi}>
      <Show when={!presenceApi().unmounted}>
        <ark.div {...mergedProps}/>
      </Show>
    </PresenceProvider>);
};
